import { LitElement, html } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map.js';




export const renderSlot = (data) => html `<slot name="${data.name}"></slot>
`
